import { render, staticRenderFns } from "./MCT.vue?vue&type=template&id=5c7f87a9&scoped=true&"
import script from "./MCT.vue?vue&type=script&lang=js&"
export * from "./MCT.vue?vue&type=script&lang=js&"
import style0 from "./MCT.vue?vue&type=style&index=0&id=5c7f87a9&lang=scss&scoped=true&"
import style1 from "./MCT.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7f87a9",
  null
  
)

export default component.exports